import { WSFormProps, WSList, WSText } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { useUserId } from "../../../../query/hooks/helpers";
import { useQueryUserProfile } from "../../../../query/users/queries";
import { verificationService } from "../../../../shared/services/verificaiton";
import { CardTaxVerificationRequirementRequester } from "../../components/CardTaxVerificationRequirementRequester";
import { useOnboardignModules, useOnboardingContext } from "../../Context";
import { OnboardingModuleCreateAccount, OnboardingStep } from "../../types";
import { CreateAccountContext } from "./types";
import { useRedirectToAccountType } from "./useRedirectToAccountType";
import { useUsPersonMissingFields } from "../../hooks/useUsPersonMissingFields";
import { useQueryUserProfileV2 } from "../../../../query/user/queries/useQueryUserProfile";
import {
  FormDataUSInternationalPersonInformation,
  FormUSInternationalPersonInformation
} from "../../components/FormUSInternationalPersonInformation";
import { useQueryVerifications } from "../../../../query/onboarding/queries/useQueryVerifications";
import { getUsPersonData } from "../../components/FormUSInternationalPersonInformation/getUsPersonData";

export const InternationalUSPersonInformation: React.FC<OnboardingStep> = ({
  onNext,
  onBack
}) => {
  const [context, setContext] = useOnboardingContext<CreateAccountContext>();

  const userId = useUserId();
  const queryUser = useQueryUserProfile(userId);
  const queryUserProfile = useQueryUserProfileV2();
  const queryVerifications = useQueryVerifications();

  const usPersonData: WSFormProps<FormDataUSInternationalPersonInformation>["defaultValues"] =
    useMemo(
      () => ({
        usPerson: getUsPersonData(queryUserProfile.data, queryUser.data)
      }),
      [queryUser.data, queryUserProfile.data]
    );

  const modules = useOnboardignModules();
  const onboardingModule = modules.find(m => m.type === "create_account") as
    | OnboardingModuleCreateAccount
    | undefined;
  const verificationLevel =
    onboardingModule?.options?.verificationLevel || "Tax";

  const usPersonMissingFields = useUsPersonMissingFields(verificationLevel);

  const isUsPersonMismatch = useMemo(
    () => verificationService.getIsUsPersonMismatch(usPersonMissingFields),
    [usPersonMissingFields]
  );

  const isUSPersonFormCompleted = useMemo(
    () => queryVerifications.data?.profiles?.["US"].tax === "Verified",
    [queryVerifications.data]
  );

  useRedirectToAccountType();

  return (
    <WSList gap="2XL">
      <CardTaxVerificationRequirementRequester />

      <FormUSInternationalPersonInformation
        defaultValues={context.usInternationalPersonInformation || usPersonData}
        onBack={onBack}
        onSubmit={data => {
          isUSPersonFormCompleted ||
            setContext(prev => ({
              ...prev,
              usInternationalPersonInformation: data
            }));
          onNext?.();
        }}
        mismatch={isUsPersonMismatch}
        completed={isUSPersonFormCompleted}
      />

      <WSText.ParagraphXs color="gray400">
        The information on this page is required to setup your Wingspan account,
        if you exit or leave without completing this step, you will return to
        this page the next time you sign-in
      </WSText.ParagraphXs>
    </WSList>
  );
};
